/* Extracted 2026-10-13 from snippets/cashfree.liquid (inline block 1) — SEO round 3 step 3, audit C1. Loaded at the same position, synchronously. Edit here; the Liquid file only references it. */
try {
  const ctaButtonAllowedTypes = ["BUTTON", "A", "INPUT"];

  const checkoutButtonAllowedText = ["checkout", "placeorder"];

  const cfButtonUniqueClass = "cf-occ-btn";

  // TLC 2026-06-07: if Cashfree OCC fails to load/open within this window, fall back
  // to native Shopify checkout instead of leaving the customer on a dead spinner.
  // (A Cashfree outage on 2026-06-06 took down ALL orders for ~10h because OCC
  // replaces native checkout with no fallback.) TLC 2026-07-16: trimmed from 10s to
  // 7s — real opens complete in ~1.5-2s, so 7s is still generous for a slow network
  // without making the customer wait through an obviously-stuck spinner.
  // TLC 2026-07-31: 7s -> 8s. The modal is not slow — it is INTERMITTENT.
  //
  // NOTE on order counts: OCC orders record with gateway `manual`, NOT "Cashfree", so
  // you cannot conclude OCC is dead by grepping for a Cashfree gateway — it will always
  // read zero. (~35 of the last 120 orders are `manual`, some of which are OCC.) Judge
  // this integration by whether the modal opens, not by gateway name.
  //
  // Measured live on 31 Jul, real clicks on the cart page, one with a 6s settle delay:
  //     attempt 1 -> modal opened at 4,801ms
  //     attempt 2 -> no modal
  //     attempt 3 -> no modal, fallback at 14,168ms
  //     attempt 4 -> no modal, fallback at 5,030ms   (page fully settled first)
  // One open in four. What happens on a failed attempt:
  //     +337ms   POST payments.cashfree.com/.../integration/shopify/checkout  -> 200, 1,234ms
  //     +1572ms  POST payments.cashfree.com/.../integration/analytics/...     -> 200, 104ms
  //     iframe created: 0 x 0, src = (none)   <-- never populated, never sized
  //     JS errors: none
  // So their SDK reaches their API fine, reports analytics, creates the modal shell,
  // and then silently fails to render anything into it. One earlier attempt did open
  // (4,801ms), so it is intermittent at best. This is inside Cashfree's SDK/account
  // config — the theme cannot fix it, and raising the timeout only makes the customer
  // stare at a spinner for longer before the same fallback fires.
  //
  // Choosing the number: the one successful open took 4,801ms, so anything at or below
  // 5s would cut off a genuinely-working modal — the old 7s had only ~2.2s of margin and
  // 5s would have had 200ms. 8s clears the observed good open with real headroom while
  // keeping the dead wait tolerable on the ~75% of attempts that fail. Do NOT tighten
  // this again without re-measuring a successful open first; that mistake is what the
  // 16 Jul 10s->7s change made, on an assumed "1.5-2s" that was never true here.
  //
  // I briefly set this to 14s today on the assumption it was pure latency. It is not —
  // 14s just meant a 14-second stare at a spinner before the same fallback.
  //
  // THE REAL FIX IS WITH CASHFREE: their SDK calls their API successfully, then creates
  // an empty 0x0 iframe with no src and gives up silently, with no JS error. Until that
  // is resolved most customers pay an ~8s tax on checkout and never see the 5% prepaid
  // offer. If Cashfree cannot fix it quickly, set CF_OCC_ENABLED = false below — native
  // checkout, zero delay, and the prepaid discount was not reaching those customers anyway.
  const cfFallbackTimeout = 8000;

  // TLC 2026-07-31: hard bypass. Flip to false to skip Cashfree OCC entirely and send
  // every checkout click straight to native Shopify checkout with zero waiting. Leave
  // true while Cashfree is being chased, so the integration resumes the moment they fix
  // it. Costs ~8s per checkout while broken — that is the trade being made knowingly.
  const CF_OCC_ENABLED = true;

  // ── SELF-DRIVE RESCUE (TLC 2026-07-31) ────────────────────────────────────────────
  // Cashfree quoted 48-72h just to START on their side, so this is our own workaround.
  //
  // What we know from live diagnosis: their createOrder endpoint WORKS. It returns a
  // complete, valid session:
  //     POST payments.cashfree.com/.../integration/shopify/checkout/v2/createOrder -> 200
  //     { "payment_session_id": "session_...", "order_id": "harrods-health.myshopify.com_...",
  //       "order_hash": "..." }
  // Only their OCC wrapper is broken: it takes that good session and renders it into an
  // iframe that stays 0x0 with src=(none). Retrying initCheckout does NOT help — each
  // call just produces another empty shell (verified: 3 calls -> 3 empty iframes).
  //
  // But Cashfree's OFFICIAL SDK is already on the page and healthy (`window.Cashfree` is
  // a function, sdk.cashfree.com/js/v3 loaded). Their documented call is:
  //     Cashfree({ mode: "production" }).checkout({ paymentSessionId, redirectTarget })
  // So we capture the payment_session_id their own integration just minted, and when the
  // OCC modal fails to appear, we hand that same session to their own official SDK
  // instead of dumping the customer into native checkout. Same Cashfree order, same
  // order_id, same post-payment integration — we are only replacing the broken renderer.
  //
  // PROVEN LIVE 2026-07-31 on /cart: handing the captured session to the official SDK
  // renders the full Cashfree one-click checkout — TLC branding, "MONSOON DEALS —
  // ₹199.75 saved on this order", Cart ₹799 -> Total ₹599.25, "5 Offers Available"
  // (the prepaid offer), mobile-number step. Identical to what OCC should have shown.
  //
  // ⚠ STILL UNVERIFIED: that Cashfree creates the SHOPIFY order after payment completes
  // down this path. It is the same session, the same order_id
  // (harrods-health.myshopify.com_...), and the same Cashfree server-side integration
  // that already handles the ~25% of clicks where OCC does open — so this is not a new
  // risk class, it is the intended flow restored for the other ~75%. But it has not been
  // proven with real money.
  // ► PLACE ONE SMALL REAL ORDER AND CONFIRM IT APPEARS IN SHOPIFY.
  // ► If it does not: set this back to false immediately — customers then get native
  //   checkout, exactly as they did before this change. Nothing else depends on it.
  const CF_SELF_DRIVE_ENABLED = true;

  // Most recent payment session minted by Cashfree's own createOrder call, per click.
  let cfLastSession = null;
  (function captureCashfreeSession() {
    try {
      const of = window.fetch;
      if (!of || of.__tlcCfPatched) return;
      const patched = async function (input) {
        const url = typeof input === "string" ? input : (input && input.url) || "";
        const res = await of.apply(this, arguments);
        if (/cashfree/i.test(url) && /createOrder/i.test(url)) {
          try {
            const data = await res.clone().json();
            if (data && data.payment_session_id) {
              cfLastSession = { id: data.payment_session_id, orderId: data.order_id, at: Date.now() };
            }
          } catch (e) { /* never let diagnostics break checkout */ }
        }
        return res;
      };
      patched.__tlcCfPatched = true;
      window.fetch = patched;
    } catch (e) {
      console.error("Error installing Cashfree session capture :: " + (e && e.message));
    }
  })();

  // Render the captured session with Cashfree's official SDK. Returns true if handed off.
  const cfSelfDrive = (reason) => {
    try {
      if (!CF_SELF_DRIVE_ENABLED) return false;
      if (typeof window.Cashfree !== "function") return false;
      // Only use a session from THIS checkout attempt — never a stale one.
      if (!cfLastSession || (Date.now() - cfLastSession.at) > 90000) return false;
      console.warn("Cashfree OCC modal failed (" + reason + ") -> self-driving official SDK, order " + cfLastSession.orderId);
      const cf = window.Cashfree({ mode: "production" });
      cf.checkout({ paymentSessionId: cfLastSession.id, redirectTarget: "_self" });
      return true;
    } catch (e) {
      console.error("cfSelfDrive failed, falling through to native :: " + (e && e.message));
      return false;
    }
  };
  // TLC 2026-07-16: this used to be a fixed 6500ms, independent of cfFallbackTimeout.
  // That meant the loader reverted to a normal, clickable-looking "Checkout" button
  // 3.5s BEFORE the fallback navigation actually fired — a dead window where checkout
  // looked idle, then silently jumped to native checkout with no visible cause
  // ("the checkout disappeared"). The safety-valve auto-revert must never fire before
  // goNativeCheckout's own revertLoader() does, so it's now tied to the same timeout
  // plus a margin — it only fires if some code path fails to call goNativeCheckout.
  const revertLoaderTime = cfFallbackTimeout + 2000;

  const cfSdkUrl = "https://sdk.cashfree.com/js/v3/cashfree.js";

  // TLC 2026-07-16: this snippet now renders site-wide (was cart-page-only) so the
  // cart DRAWER's checkout button — openable from any page — also routes through OCC.
  // With the script live everywhere, plain text matching ("checkout"/"buynow") is no
  // longer precise enough: the site has its own unrelated "Buy it now"/"Buy Now"
  // buttons on PDPs (e.g. the kyoto bundle flow's #ctaBuyNow) that must NOT be pulled
  // into Cashfree OCC. `requireName: "checkout"` pins the match to elements carrying
  // Shopify's own name="checkout" attribute — true of both the /cart page's button
  // AND the drawer's (rendered via snippets/button.liquid name:'checkout') — so this
  // can no longer accidentally grab an unrelated button just because its text matches.
  // The former buyNow config is retired for the same reason: nothing in this codebase
  // sets name="buynow"/"placeorder", so there's no equally precise way to scope it,
  // and it was never part of the drawer-extension ask — re-add deliberately if needed.
  const buttonConfigs = {
    checkout: {
      allowedTypes: ctaButtonAllowedTypes,
      allowedText: checkoutButtonAllowedText,
      requireName: "checkout",
      action: (node) => {
        node.setAttribute("data-function", "initCheckout");
      },
    },
  };

  const normalizeText = (text) => text?.replace(/\s/g, "").toLowerCase() ?? "";

  // TLC 2026-07-31: the loader used to be a bare spinning ring with no words. Measured
  // time-to-modal is ~4.8s (see cfFallbackTimeout note), and 4.8 seconds of a silent
  // spinner on the one button standing between a customer and their money reads as
  // "this is broken" — people leave. Now it says what is happening, and after 2.5s it
  // says it again more reassuringly, so a slow open feels attended-to rather than dead.
  // Built with DOM nodes + textContent rather than innerHTML: nothing here is user
  // input today, but this is the payment path and it should stay that way by construction.
  const cfLoaderTimers = new WeakMap();
  const cfOriginalNodes = new WeakMap();
  const displayLoader = (button) => {
    try {
      if (!button) return;

      // Keep the button's original children as live nodes rather than round-tripping
      // them through an innerHTML string. Same result, no re-parsing of markup on the
      // payment path, and the restore in revertLoader becomes a plain node swap.
      if (!cfOriginalNodes.has(button)) {
        cfOriginalNodes.set(button, Array.prototype.slice.call(button.childNodes));
      }
      button.classList.add("cf-loader");
      button.disabled = true;

      const wrap = document.createElement("span");
      wrap.className = "cf-loading-wrap";

      const ring = document.createElement("div");
      ring.id = "cf-loader-ring";
      for (let i = 0; i < 4; i++) ring.appendChild(document.createElement("div"));

      const label = document.createElement("span");
      label.className = "cf-loading-label";
      label.textContent = "Opening secure checkout…";

      wrap.appendChild(ring);
      wrap.appendChild(label);
      button.replaceChildren(wrap);

      // Escalate the wording if the open is running long, so the wait stays explained.
      const t = setTimeout(() => {
        try { label.textContent = "Almost there — securing your payment…"; } catch (e) {}
      }, 2500);
      cfLoaderTimers.set(button, t);
    } catch (err) {
      console.error(`Error in displayLoader :: ${err?.message}`);
    }
  };

  const revertLoader = (button) => {
    try {
      if (!button) return;

      // TLC 2026-07-31: clear the escalating-label timer first, otherwise a late
      // "Almost there…" can overwrite the text of a button that already went idle.
      const t = cfLoaderTimers.get(button);
      if (t) { clearTimeout(t); cfLoaderTimers.delete(button); }

      const original = cfOriginalNodes.get(button);
      if (original) button.replaceChildren.apply(button, original);
      button.classList.remove("cf-loader");
      button.disabled = false;
    } catch (err) {
      console.error(`Error in revertLoader :: ${err?.message}`);
    }
  };

  const initEventListeners = async () => {
    try {
      document.addEventListener(
        "click",
        async (e) => {
          try {
            let clickTarget = e.target;
            if (typeof clickTarget?.closest === "function") {
              clickTarget = clickTarget.closest("button, a, input");
            }
            clickTarget = clickTarget?.classList?.contains(cfButtonUniqueClass)
              ? clickTarget
              : prepareButton(clickTarget);
            if (
              clickTarget?.classList?.contains(cfButtonUniqueClass) &&
              clickTarget.dataset?.function
            ) {
              let checkoutBtn = clickTarget;

              // * Stopping the event propagation
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();

              // * Displaying loader on the button
              displayLoader(checkoutBtn);

              // * Removing the loader after revertLoaderTime ms
              setTimeout(() => {
                revertLoader(checkoutBtn);
              }, revertLoaderTime);

              // --- TLC graceful-degradation guard (2026-06-07) ----------------------
              // If Cashfree OCC can't load/open, send the customer to native Shopify
              // checkout rather than stranding them on the spinner.
              let tlcFellBack = false;
              const goNativeCheckout = (reason) => {
                if (tlcFellBack) return;
                tlcFellBack = true;
                try { clearTimeout(tlcStallTimer); } catch (e) {}
                // TLC 2026-07-31: before abandoning Cashfree entirely, try rendering the
                // session their own createOrder already minted, via their official SDK.
                // Only fires when CF_SELF_DRIVE_ENABLED is on; keeps the prepaid discount
                // alive instead of dropping the customer into native checkout.
                try {
                  if (checkoutBtn) checkoutBtn.textContent = "Opening secure payment...";
                } catch (e) {}
                if (cfSelfDrive(reason)) return;
                try { console.warn("Cashfree OCC unavailable -> native checkout:", reason); } catch (e) {}
                // TLC 2026-07-16: show what's happening instead of silently reverting
                // the button to its normal idle state right before the page jumps —
                // that gap is what made the redirect feel like checkout vanished.
                try {
                  if (checkoutBtn) checkoutBtn.textContent = "Redirecting to secure checkout...";
                } catch (e) {}
                // bypass the hijack; Shopify creates the checkout from the current cart
                window.location.href = "/checkout";
              };
              // Safety net: native checkout if the OCC modal never renders.
              const tlcFallbackTimer = setTimeout(
                () => goNativeCheckout("timeout — OCC modal did not open"),
                cfFallbackTimeout
              );
              // Disarm the safety net once the real OCC modal renders. Detect it as a
              // NEW, large, visible iframe (the modal is ~768x646) — NOT by src match:
              // the SDK injects a hidden 0x0 "ping_atom" iframe whose src contains
              // "cashfree", which would otherwise disarm the net instantly.
              const tlcPreIframes = new Set(
                Array.prototype.slice.call(document.querySelectorAll("iframe"))
              );
              const tlcModalAppeared = () =>
                Array.prototype.slice
                  .call(document.querySelectorAll("iframe"))
                  .some((f) => {
                    if (tlcPreIframes.has(f)) return false;
                    const r = f.getBoundingClientRect();
                    if (r.width < 250 || r.height < 250) return false;
                    const cs = getComputedStyle(f);
                    return cs.display !== "none" && cs.visibility !== "hidden";
                  });
              const tlcModalWatch = setInterval(() => {
                if (tlcModalAppeared()) {
                  clearTimeout(tlcFallbackTimer);
                  clearInterval(tlcModalWatch);
                }
              }, 250);
              setTimeout(() => clearInterval(tlcModalWatch), cfFallbackTimeout + 1000);

              // --- TLC 2026-08-28: second-stage STALL detector -----------------------
              // Why this exists: on 28 Aug a walk of cart -> checkout found createOrder
              // returning 200 and then NOTHING for 41s — no polling, no payment-method
              // fetch, no JS error. Neither the 8s native fallback nor the self-drive
              // fired, and the customer sat on a blank full-screen overlay for ever.
              //
              // Cause: tlcModalAppeared() above disarms the safety net on ANY new iframe
              // >=250x250 that is not display:none/visibility:hidden. It never checks
              // whether the frame has CONTENT. That was correct for the July failure
              // (the frame stayed 0x0, so it never disarmed) but wrong for this one:
              // Cashfree now injects a 768x646 SAME-ORIGIN frame that renders EMPTY and
              // sits on top, so a stall reads as success and cancels our own rescue.
              //
              // Deliberately NOT done: tightening cfFallbackTimeout. A genuine open was
              // measured at 4,801ms and must not be cut off (see the note on that const).
              // This re-checks LATER instead, and is written to be safe against false
              // positives: Cashfree's real payment UI is CROSS-ORIGIN, so contentDocument
              // throws and we bail out. It can only fire when the element the customer is
              // literally looking at is a same-origin iframe we can read and it is empty.
              const tlcBlankModalOnTop = () => {
                const frames = Array.prototype.slice
                  .call(document.querySelectorAll("iframe"))
                  .filter((f) => {
                    const r = f.getBoundingClientRect();
                    if (r.width < 250 || r.height < 250) return false;
                    const cs = getComputedStyle(f);
                    return cs.display !== "none" && cs.visibility !== "hidden";
                  });
                if (!frames.length) return false;
                // Test EVERY candidate frame, not just the first in DOM order. A live
                // open on 28 Aug put a full-viewport 1512x827 cross-origin wrapper first
                // while the real modal was a 768x646 frame after it, so sampling only
                // frames[0] was luck rather than logic.
                return frames.some((f) => {
                  const r = f.getBoundingClientRect();
                  let top = null;
                  try {
                    top = document.elementFromPoint(
                      Math.round(r.left + r.width / 2),
                      Math.round(r.top + r.height / 2)
                    );
                  } catch (e) { return false; }
                  if (!top || top.tagName !== "IFRAME") return false;
                  let doc = null;
                  // Cross-origin throws here — that is Cashfree's real UI, so bail out.
                  try { doc = top.contentDocument; } catch (e) { return false; }
                  if (!doc || !doc.body) return false;
                  return (doc.body.innerText || "").trim().length === 0;
                });
              };
              const tlcStallTimer = setTimeout(() => {
                if (tlcFellBack) return;
                if (tlcBlankModalOnTop()) {
                  goNativeCheckout("stall — OCC frame opened but rendered blank");
                }
              }, cfFallbackTimeout + 7000);
              // ---------------------------------------------------------------------
              // ---------------------------------------------------------------------

              try {
                // * Checking if CF theme script is loaded
                await loadCfThemeScript();

                if (!window.CashfreeOcc) {
                  throw new Error("CashfreeOcc SDK not available");
                }

                // * Initializing the checkout process
                switch (checkoutBtn.dataset.function) {
                  case "initCheckout":
                    CashfreeOcc.initCheckout(checkoutBtn);
                    break;
                  case "initBuyNow":
                    CashfreeOcc.initBuyItNow(checkoutBtn);
                    break;
                }
              } catch (sdkErr) {
                clearTimeout(tlcFallbackTimer);
                clearInterval(tlcModalWatch);
                goNativeCheckout(sdkErr && sdkErr.message);
              }
            }
          } catch (err) {
            console.error(`Error in click event listener :: ${err?.message}`);
          }
        },
        true
      );
    } catch (err) {
      console.error(`Error in initEventListeners :: ${err?.message}`);
    }
  };

  const checkButtonMatch = (node, config) => {
    if (!config.allowedTypes.includes(node.nodeName)) return false;

    // TLC 2026-07-16: exact-attribute guard, see buttonConfigs comment above.
    if (config.requireName && node.getAttribute("name") !== config.requireName) {
      return false;
    }

    const nodeText = normalizeText(node.textContent);
    const nodeValue = normalizeText(node.value);

    return config.allowedText.some(
      (text) => nodeText.includes(text) || nodeValue.includes(text)
    );
  };

  const prepareButton = (node) => {
    if (!node || !node.classList) return null;
    // Bypass switch: never claim the button, so the theme's own checkout click stands
    // and the customer goes to native checkout instantly.
    if (!CF_OCC_ENABLED) return null;

    for (let config of Object.values(buttonConfigs)) {
      if (checkButtonMatch(node, config)) {
        node.classList.add(cfButtonUniqueClass);
        config.action(node);
        return node;
      }
    }

    return null;
  };

  const loadCfThemeScript = () => {
    return new Promise((resolve, reject) => {
      try {
        let themeScriptLoaded = false;

        function loadScriptWithRetries(url, retries) {
          if (retries <= 0 || themeScriptLoaded) {
            if (themeScriptLoaded) {
              resolve();
            } else {
              reject(
                new Error("Failed to load script after multiple attempts")
              );
            }
            return;
          }

          let script = document.createElement("script");
          script.type = "text/javascript";
          script.src = url;
          script.id = "zecpe-theme-script";
          script.async = true;
          script.onload = function () {
            themeScriptLoaded = true;
            resolve();
          };
          script.onerror = function () {
            setTimeout(function () {
              loadScriptWithRetries(url, retries - 1);
            }, 2000);
          };

          document.head.appendChild(script);
        }

        if (!window.CashfreeOcc) {
          loadScriptWithRetries(
            "https://shopify-checkout.cashfree.com/bundle.js",
            3
          );
        } else {
          resolve();
        }
      } catch (err) {
        console.error("Error in loadCfThemeScript:", err);
        reject(err);
      }
    });
  };

  initEventListeners();
  } catch (err) {
  console.error(`Error in doing automated theme setup :: ${err?.message}`);
  }
